import Area from './area-container'
export default Area
